<div mat-dialog-title style="position: relative;" *ngIf="isTicket">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        Ticket history
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onNoClick()"
    style="color: black; top: 0px;left: 300px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content *ngIf="isTicket">
    <div *ngFor="let _t of dataArray; let i=index;">

        <div
          *ngIf="_t.TicketType!='MatchFollowUpStatus' && _t.TicketType !=='INTERNAL MEMO' &&  _t.TicketType != 'MatchFollowupReply'">
          <div class="row ka-em-header-content">
            <span>{{_t.TicketInfo}}</span>

          </div>
          <div class="row">
            <div class="col-md-4 ka-em-tkt-header">Call Done By</div>
            <div class="col-md-8">{{_t.EmployeeName}}</div>
          </div>
          <div class="row">
            <div class="col-md-4 ka-em-tkt-header">Call Status</div>
            <div class="col-md-8">{{_t.CallResult}}</div>
          </div>
          <div class="row">
            <div class="col-md-4 ka-em-tkt-header">Call Received By</div>
            <div class="col-md-8">{{_t.Relation}}
              <span *ngIf="_t.Relation !=null && _t.Relation !=''">({{_t.RelationName}})</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 ka-em-tkt-header">
              <span>Call Discussion</span>

            </div>

          </div>
          <div class="row" style="padding-left: 5%;">
            <span class="ka-mf-cd" *ngIf="_t.Body !=null && _t.Body!=''">{{_t.Body}}</span>
            <span *ngIf="_t.Body ===null && _t.Body===''">--</span>

          </div>
        </div>
        <div
          *ngIf="_t.TicketType==='MatchFollowUpStatus' || _t.TicketType ==='INTERNAL MEMO' || _t.TicketType === 'MatchFollowupReply'">
          <div class="row ka-em-header-content">
            <span>{{_t.TicketInfo}}</span>

          </div>
          <div class="row">
            <div class="col-md-5 ka-em-tkt-header">Employee Name</div>
            <div class="col-md-7">{{_t.EmployeeName}}</div>
          </div>
          <div class="row">
            <div class="col-md-4 ka-em-tkt-header">
              <span>Comments</span>

            </div>

          </div>
          <div class="row" style="padding-left: 5%;">
            <span *ngIf="_t.Body !=null && _t.Body!=''">{{_t.Body}}</span>
            <span *ngIf="_t.Body ===null && _t.Body===''">--</span>

          </div>
        </div>


      </div>
</div>

<div mat-dialog-title style="position: relative;" *ngIf="officePurpose">
  <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
  margin-left: -24px;margin-right: -24px;" *ngIf="dataArray.length>0">
  Profile Description
  </p>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onNoClick()"
  style="color: black; top: 0px;right:0;position: absolute;" *ngIf="dataArray.length>0">
      <span aria-hidden="true" class="">&times;</span>
  </button>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onNoClick()"
  style="color: black; top: -35px;right:0;position: absolute;">
      <span aria-hidden="true" class="">&times;</span>
  </button>
</div>
<div mat-dialog-content *ngIf="officePurpose">
  <div class="p-3">    
    <table class="ka-em-profile-details py-4" *ngIf="dataArray.length>0">
        <tr class="row ka-officeDesc-content">
            <th class="col-3 text-center">Created Employee</th>
            <th class="col-2 text-center">Created Date</th>
            <th class="col-7 text-center">Profile Description</th>
            <!-- <th class="col-3 text-center">Actions</th>                 -->
          </tr>
          <tr class="row ka-officeDesc-content " *ngFor="let value of dataArray">
            <td class="col-3 text-center">{{value.Created}}</td>
            <td class="col-2 text-center">{{value.CreatedDate | date: 'mediumDate'}}</td>
            <td class="col-7 text-center">{{value.AboutProfile}}</td>
            <!-- <td class="col-3 text-center"><span (click)="updateActions({element: value, type: 'update'})" class="edit-button">Edit</span>
                <span (click)="updateActions({element: value, type: 'delete'})" class="delete-button">Delete</span></td>                 -->
          </tr>
        
        
        <!-- <div class="col-md-8">
            <span></span>
            <span>{{value.AboutProfile}}</span>
        </div>

        <div class="col-md-2">
            <span>Actions</span>
            <span (click)="updateActions({element: value, type: 'update'})" class="edit-button">Edit</span>
            <span (click)="updateActions({element: value, type: 'delete'})" class="delete-button">Delete</span>
        </div> -->
    </table>
    <div class="row" *ngIf="dataArray.length === 0">
<div class="col text-center"><p>Please Fill Office Purpose</p></div>
    </div>
</div>
</div>